import { Component } from "@angular/core";
import { PonderAuthClient } from "@apiserver-rest/ponder-auth-client";
import { GetPaymentMethodsResponse, PaymentMethod } from "@apiserver-rest/ponder-auth-client-base";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { Subscription, take } from "rxjs";
import { UserPaymentMethod } from "./user-payment-method.component";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { NewPaymentMethodComponent } from "./new-payment-method.component";

@Component({
    selector: "user-payment-methods",
    imports: [LoadingComponent, UserPaymentMethod, NewPaymentMethodComponent],
    templateUrl: "./user-payment-methods.component.html"
})
export class UserPaymentMethodsComponent {

    public readonly addSvgIcon: SvgIcon = SvgIcon.New;
    
    public isLoading: boolean = true;
    public error: boolean = false;
    public errorMessage?: string;

    public paymentMethods: PaymentMethod[] = [];
    private paymentMethodRemovedSub!: Subscription;

    public constructor(private ponderAuthClient: PonderAuthClient, private events: EventBroker) {
        this.paymentMethodRemovedSub = this.events.account.paymentMethodRemovedEvent.subscribe({
            next: (paymentMethodId: string) => {
                this.onPaymentMethodRemoved(paymentMethodId);
            }
        });
    }

    public ngOnDestroy() {
        this.paymentMethodRemovedSub.unsubscribe();
    }

    public ngOnInit(): void {
        this.ponderAuthClient
            .subscriptionPaymentMethodList()
            .pipe(take(1))
            .subscribe({
                next: (response: GetPaymentMethodsResponse) => {
                    if (response.success) {
                        this.paymentMethods = response.paymentMethods ?? [];
                    } else {
                        this.error = true;
                        this.errorMessage = "Error retrieving payment methods.";
                    }
                },
                error: () => {
                    this.error = true;
                    this.errorMessage = "Error retrieving payment methods.";
                }
            })
            .add(() => { this.isLoading = false });
    }

    private onPaymentMethodRemoved(paymentMethodId: string): void {
        const index = this.paymentMethods.findIndex((paymentMethod: PaymentMethod) => {
            return paymentMethod.id == paymentMethodId;
        });

        if (index >= 0) {
            this.paymentMethods.splice(index, 1);
        }
    }
}